import AnimatedBrandText from '../home/AnimatedBrandText';
import { useTeamBrand } from '../branding/TeamBrandContext';
import './XiaoyingLoading.css';

export default function XiaoyingLoading({
  label = '正在准备创作空间',
  detail,
  variant = 'page',
  className = '',
}) {
  const brand = useTeamBrand();
  return (
    <div
      className={`xiaoying-loading is-${variant} ${className}`.trim()}
      role="status"
      aria-label={label}
      aria-live="polite"
    >
      <div className="xiaoying-loading__mark" aria-hidden="true">
        <span className="xiaoying-loading__aura" />
        {brand.active && brand.logoUrl && !brand.wordmarkUrl
          ? <img src={brand.logoUrl} alt="" className="relative z-[1] block max-h-10 max-w-[180px] object-contain" />
          : <AnimatedBrandText />}
        <span className="xiaoying-loading__sheen" />
      </div>
      <div className="xiaoying-loading__copy">
        <strong>{label}</strong>
        {detail && <span>{detail}</span>}
      </div>
      <span className="xiaoying-loading__progress" aria-hidden="true"><i /></span>
    </div>
  );
}
